import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { Period } from '../../entities/control-tables/period';

export class PeriodRequest extends BaseRequest {

    period : Period

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.period = new Period()
  }
}